import { render } from "./PotGrid.vue?vue&type=template&id=4e524168"
import script from "./PotGrid.vue?vue&type=script&lang=js"
export * from "./PotGrid.vue?vue&type=script&lang=js"

import "./PotGrid.vue?vue&type=style&index=0&id=4e524168&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__